import React, {Component} from 'react';
import {Col, Container, Row} from 'reactstrap';
import Skills from './components/Skills';
import Section from "./components/Section";
import Intro from './components/Intro';
import * as Constants from '../../Constants/Constants';
import {KEY_NORMAL, SUBTITLE_LINK_INLINE} from '../../Constants/Constants';
// import {data} from '../../store/data';


class MiniPage extends Component {

	constructor(props) {
		super(props);
		this.state = {
			data: props.data,
			minWidth: 320
		}
	}

	componentDidMount() {
	}

	//border: "5px solid #607d8b"
	styles = {
		container: {
			// backgroundImage: "linear-gradient(to right, #7E57C2, #FFFDE7)"
			//backgroundColor: "#7E57C2"
		},
		paper: {
			maxWidth: "576px",
			padding: "0px 10px",
			margin: "0px auto",
			// border: "1px solid #311B92",
			borderRadius: "5px",
			color: "#311B92",
			//backgroundColor: "#fff",
		},
		title: {
			fontWeight: 500,
		},
		designation: {
			fontWeight: 400,
			fontStyle: 'italic'
		},
		keyValue: {
			padding: "0",
			margin: "0"
		},
		sidebar: {
			padding: "1rem",
			borderTopRightRadius: "0",
			borderBottomRightRadius: "0",
			borderRadius: "5px",
			backgroundColor: "#4527A0",
			color: "#fff",
		},
		'rightSidebar': {
			padding: "1rem"
		},
		sidebarLink: {
			color: "#E8F5E9"
		},
		link: {
			color: "#7E57C2"
		},
		social_links: {
			color: "#4527A0",
		},

		section: {
			backgroundColor: "#fff",
			padding: "1rem",
			marginBottom: "1.5rem",
			// border: "1px solid #311B92",
			borderRadius: "5px",
			// backgroundImage: "linear-gradient(to right, #FFFF8D, #FFFDE7)"
			boxShadow: "0 0 20px 2px #555",
			item: {
				paddingBottom: "0.5rem",
				fontSize: "1rem",
				lineHeight: "1.3rem",
				fontWeight: 400,
				title: {fontWeight: 500, lineHeight: "1.5rem"},
				subTitle: {fontStyle: "italic"},
				description: {},
				duration: {fontWeight: 500, width: "max-content"},
			},
			timelineLight: {
				color: 'rgba(255, 255, 255, 1)',
				topBallColor: 'white',
				bottomBallColor: 'white'
			},
			timelineDark: {
				color: 'rgba(0, 0, 0, 0.4)',
				topBallColor: '#4527A0',
				bottomBallColor: '#7E57C2'
			},
		}
	};

	render() {
		const data = this.state.data;
		let kvs = data.kvs;
		let social = data.social;
		let skills = data.skills;
		let education = data.education;
		let internships = data.internships;
		let projects = data.projects;
		let courses = data.courses;
		// if(this.props.window_width > 1024){
		// 	return <AlertModal message="This Page is suitable for small screens only."/>
		// }

		return (
			<Container fluid className="no-gutters p-0" style={this.styles.container}>
				<div style={this.styles.paper}>
					<Row>
						<Col style={this.styles.rightSidebar}>
							<Intro
								containerStyle={this.styles.section}
								title={data.title}
								subtitle={data.subtitle}
								showQR={false}
								qrcode="https://lalitjain98.github.io/my-resume"
								styles={this.styles}
								data={kvs}
								social={social}
								socialLinkSize={KEY_NORMAL}
							/>
							<Section
								styles={this.styles}
								title="Projects"
								data={projects.filter(item=>item.isImportant)}								linkPosition={this.props.window_width > this.state.minWidth ? SUBTITLE_LINK_INLINE : null}
								// datePosition={this.props.window_width > this.state.minWidth ? Constants.DATE_INLINE : Constants.DATE_IN_ROW}
								datePosition={Constants.DATE_INLINE}
								dateFormat={Constants.END_DATE}
								showDescription={false}
								linkStyles={this.styles.link}
							/>
							<Section
								styles={this.styles}
								title="Past Internships"
								data={internships}
								datePosition={Constants.DATE_INLINE}
								dateFormat={Constants.END_DATE}
								showDescription={false}
								linkStyles={this.styles.link}
								linkPosition={SUBTITLE_LINK_INLINE}
								linkAlign={'left'}
								isSubtitleLink={true}
							/>
							<Section
								styles={this.styles}
								title="Education"
								data={education}
								datePosition={Constants.DATE_INLINE}
								dateFormat={Constants.END_DATE}
								showDescription={false}
								linkStyles={this.styles.link}/>
							<Skills
								styles={this.styles}
								commaSeparated
								data={skills}
							/>
							<Section
								styles={this.styles}
								title="Courses and Certificates"
								data={courses}
								linkPosition={this.props.window_width > this.state.minWidth ? SUBTITLE_LINK_INLINE : null}
								datePosition={Constants.DATE_INLINE}
								dateFormat={Constants.END_DATE}
								showDescription={false}
								linkStyles={this.styles.link}/>
						</Col>
					</Row>
				</div>
			</Container>
		);
	}
}

export default MiniPage;